import React from 'react';
import ServicePage from '../../components/site/ServicePage';
import { RECEIPT_FAQS as FAQS } from '../../site/faqs';

export default function DigitalReceipt() {
  return (
    <ServicePage
      path="/digital-receipt"
      eyebrow="Digital receipt"
      title="A living receipt by text, not a slip or an email."
      lead="Every register today prints a slip or sends an email, and the customer calls you for everything after that. This receipt connects to where you take payment, goes out by text on its own the moment the sale rings up, carries a status on every piece, and answers the customer’s questions in the same thread, any hour."
      proof={{ label: 'See it in the live demo', href: '/phone-agent#live-demo' }}
      features={[
        { title: 'Sent on its own', text: 'Connected to your register or payment system. The sale rings up, the text goes out. Nothing for staff to remember.' },
        { title: 'Itemized by text', text: 'Every piece, colour, price, deposit, and balance. No app, no login.' },
        { title: 'A status on every line', text: 'Ready, on the truck, delivered, balance due. Staff tap once and the customer’s copy updates, so they always know where the order stands.' },
        { title: 'Questions answered from the order', text: 'Where is my dining set, what is my balance, when is the truck. The AI knows the receipt, the order, the delivery, and your store’s answers, so the customer does not call.' },
        { title: 'Staff can step in', text: 'Your reply lands in the same thread.' },
        { title: 'Split deliveries handled', text: 'Three pieces, three statuses, one thread.' },
        { title: 'Works with what you run', text: 'Receipt book, Furniture Wizard, or STORIS and other ERPs.' },
      ]}
      customer={{
        title: 'What your customer gets',
        items: [
          { title: 'One thread for the whole order', text: 'The receipt, the updates, and the answers.' },
          { title: 'No call needed', text: '"Where is my order" is answered in seconds by text.' },
          { title: 'A record they keep', text: 'Months later it is still on their phone and still answers.' },
        ],
      }}
      steps={[
        { title: 'The sale rings up', text: 'Connected to your register, the receipt sends itself. Without a connection, staff build it in seconds with catalog autocomplete.' },
        { title: 'The customer gets the text', text: 'At the counter, before they reach the parking lot.' },
        { title: 'The receipt keeps living', text: 'Statuses move as pieces arrive, load, and deliver. Questions get answered in the thread. Months later it still works.' },
      ]}
      faqs={FAQS}
      closing={{ title: 'See one on your phone.', text: 'Book 30 minutes and we will text you a receipt during the call.' }}
    />
  );
}
